import { lazy } from 'react';
const ConfirmEmail = lazy(() => import('./ConfirmEmail'));
const Login = lazy(() => import('./Login'));
const ForgotPassword = lazy(() => import('./ForgotPassword'));
const ResetPassword = lazy(() => import('./ResetPassword'));
const SignUp = lazy(() => import('./SignUp'));
const Handspring = lazy(() => import('./Handspring'));
const HTSSignUp = lazy(() => import('./HTSSignUp'));
const HTSProfileSetup = lazy(() => import('./HTSProfileSetup'));
const ProfileSetup = lazy(() => import('./ProfileSetup'));
const SitePersonalization = lazy(() => import('./SitePersonalization'));
const PaymentRequired = lazy(() => import('./PaymentRequired'));
const LoginWithToken = lazy(() => import('./LoginWithToken'));
const UseApp = lazy(() => import('./UseApp'));
const SignUpWithPurchase = lazy(() => import('./SignUpWithPurchase'));
const RedirectToDocument = lazy(() => import('./RedirectToDocument'));
const SignInToApp = lazy(() => import('./SignInToApp'));

export {
  Login,
  UseApp,
  SignUp,
  HTSSignUp,
  Handspring,
  SignInToApp,
  ConfirmEmail,
  ForgotPassword,
  ResetPassword,
  HTSProfileSetup,
  ProfileSetup,
  SitePersonalization,
  PaymentRequired,
  LoginWithToken,
  SignUpWithPurchase,
  RedirectToDocument,
};
